import s from './style.css';
import Container from 'elements/container';

const Header = ({
	siteName = 'Faces of Energy',
	links = [
		{
			link: 'https://www.seforall.org/terms-service',
			name: 'Terms of service'
		},
		{ link: 'https://www.seforall.org/privacy-policy', name: 'Privacy policy' }
	],
	logos = [
		{
			url: 'https://www.seforall.org',
			logo: '/seforall-logo-bw.svg',
			width: 80,
			height: 80,
			alt: 'SE4ALL'
		},
		{
			url: 'http://www.energia.org',
			logo: '/energia-logo-bw.svg',
			width: 225,
			height: 65,
			alt: 'Energia'
		}
	]
}) => (
	<div className={s.wrapper}>
		<footer className={s.footer}>
			<Container className={s.inner}>
				<div className={s.links}>
					{links.map(({ link, name }) => (
						<span className={s.link}>
							<a href={link} rel="noopener" target="_blank">
								{name}
							</a>{' '}
						</span>
					))}
				</div>

				<div className={s.logos}>
					{logos.map(({ logo, url, width, height, alt }) => (
						<span className={s.logo}>
							<a href={url} rel="noopener" target="_blank">
								<img src={logo} alt={alt} width={width} height={height} />
							</a>{' '}
						</span>
					))}
				</div>
			</Container>
		</footer>
	</div>
);

export default Header;



// WEBPACK FOOTER //
// ./components/footer/index.js